import call from 'utils/functions/call.util';
import withOptions from 'utils/functions/withOptions.util';
import logger from 'utils/logger.util';

const CTAG = 'readFile';
const L = logger(CTAG);

const withListener = (listener, reader) => {
  // success, fail, cancel events
  reader.addEventListener('load', listener);
  reader.addEventListener('error', listener);
  reader.addEventListener('abort', listener);
  // progress events
  reader.addEventListener('loadstart', listener);
  reader.addEventListener('loadend', listener);
  reader.addEventListener('progress', listener);

  return reader;
};

const readFile = withOptions(({ file, listener: listenerFromOptions }) => {
  if (!(file instanceof Blob)) {
    L.warn('()', 'Not a blob, file:', file);
    return '';
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    const listener = (ev) => {
      call(`${CTAG} listener`, listenerFromOptions, ev);

      if (ev.type === 'load') resolve(reader.result);
      if (ev.type === 'error') reject(reader.result);
      if (ev.type === 'abort') {
        L.info('()', 'Aborted reading, file:', file);
        resolve(reader.result);
      }
    };

    withListener(listener, reader).readAsDataURL(file);
  });
});

export default readFile;
